import { Main } from '@shared/models/Main.model';

export class State extends Main {
  id: number = -1;
  name: string = '';
  country_id: number = 0;
  country: string = '';
  [key: string]: any;
}
